import * as actionTypes from '../actions/actionTypes';
import {updateObject} from '../../helpers/utility';

const initialState = {
  error: null,
  loading: false,
};

const agentBreakStart = (state, action) => {
  return updateObject(state, {loading: true});
};

const agentBreakSuccess = (state, action) => {
  return updateObject(state, {
    error: null,
    loading: false,
  });
};

const agentBreakFail = (state, action) => {
  return updateObject(state, {error: action.error, loading: false});
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.AGENT_BREAK_START:
      return agentBreakStart(state, action);
    case actionTypes.AGENT_BREAK_SUCCESS:
      return agentBreakSuccess(state, action);
    case actionTypes.AGENT_BREAK_FAIL:
      return agentBreakFail(state, action);
    default:
      return state;
  }
};

export default reducer;
